import React from 'react';
import { Tooltip, Typography } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { IMenuItemWrapper } from './types';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    link: {
        textDecoration: 'none',
        color: 'inherit',
    },
}));

/**
 * Represents the menu item wrapper for the dashboard layout.
 * It is used to wrap the menu item and add a tooltip if it has one.
 *
 * @param {IMenuItemWrapper} {
 *     hasTooltip,
 *     tooltip,
 *     isLeaf,
 *     path,
 *     children,
 * }
 * @return {*}
 */
export const MenuItemWrapper = ({
    hasTooltip,
    tooltip,
    isLeaf,
    path,
    children,
}: IMenuItemWrapper) => {
    const { t } = useTranslation();
    const classes = useStyles();

    if (hasTooltip && path)
        return (
            <Tooltip
                title={
                    <Typography
                        variant="body1"
                        style={{ whiteSpace: 'pre-line', fontSize: 14 }}
                    >
                        {t(tooltip || '')}
                    </Typography>
                }
                placement="right"
            >
                <NavLink to={path} className={classes.link}>
                    <div>{children}</div>
                </NavLink>
            </Tooltip>
        );

    if (isLeaf && path)
        return (
            <NavLink to={path} className={classes.link}>
                {children}
            </NavLink>
        );

    return <div>{children}</div>;
};
